
import React, {useState, useEffect} from "react"
import { Row, Col, Button, Spin } from 'antd'
import classes from './styles.module.css'
import { useTranslation } from "react-i18next"
import i18n from '../../translation'
import { useRoute } from '../../hooks/useRoute'
import { useParams, useNavigate } from 'react-router-dom'



import HelmetComponent from '../../components/Helmet'
import TitleAndSubtitleAndBtn from '../../components/PageComponents/TitleAndSubtitleAndBtn'
import ViewPointsComponent from '../Exploration/viewPoints'
import LiefletComponent from './Lieflet'

import RouteSvg from '../../img/svg/route'
import MapSvg from '../../img/svg/map'
import {ChangeMunicipality} from '../../components/Box/ChangeMunicipality'

const Routes: React.FC = () => {

  const { id } = useParams()
  const { isLoading, RouteData, refetch } = useRoute(id||'')
  const navigate = useNavigate();


  const { t } = useTranslation()

  const [route, setRoute] = useState<any>({})
  const [polyline, setPolyline] = useState<[number, number][][]>([])
  const [routePoises, setRoutePoises] = useState<[number, number][][]>([])
  const [showMap, setShowMap] = useState<boolean>(false)

  const [latitude, setLatitude] = useState<string>('')
  const [longitude, setLongitude] = useState<string>('')
  const [setPoisesMarkerExploration, PoisesMarkerExploration] = useState<any[]>([])
  
  useEffect(() => {
    if (RouteData) 
      setRoute(RouteData)

  }, [RouteData])


  useEffect(() => {

    let polyline: any[] = []
    let addPois: any[] = []
    let RoutePoises: any[] = []

    if ( Object.keys(route).length !== 0 ) {

        route.route_coordinates.forEach((popyl: any, j: any, row: any): void => {
          if (j + 1 === row.length) {
            addPois.push({ id: route.pois.length + 1, latitude: parseFloat(popyl.latitude), longitude: parseFloat(popyl.longitude), name: 'Finish' })
          }
          polyline.push([parseFloat(popyl.latitude), parseFloat(popyl.longitude)])
        })

      route.pois.forEach((poi: any): void => {

          RoutePoises.push({
            main_id: route.id,
            id: poi.id,
            latitude: parseFloat(poi.latitude),
            longitude: parseFloat(poi.longitude),
            image: poi.main_image,
            title: poi.name,
            text: poi.portal_main_info,
            category: poi.categories[0].name,
            rating: poi.rating !== null ? poi.rating : 0,
            municipality: poi.extras._municipalityName.value,
          })
        })

      setPolyline(polyline)
      setRoutePoises(RoutePoises)
      setLatitude(route.lat)
      setLongitude(route.lng)

    }

  },[ route ])


  
  useEffect(() => {
    refetch()
  }, [i18n.language])

  if (isLoading || routePoises.length < 1 ) {
    return (
      <Row justify="center" >
        <Col span={12} offset={6}>
          <div className={classes.loadingSpinner}> <Spin size="large" /> {t('Παρακαλώ περιμένετε')} ... </div>
        </Col>
      </Row>
    )
  }

  return (
    <>
      
      <HelmetComponent
        title={route.title}
        descrition={route.title+', ' + ChangeMunicipality(t(route.municipality))}
        keywords='Εξερεύνηση'
      />
     
      <TitleAndSubtitleAndBtn title={route.title} subTitle={t(route.type)}/>

      {showMap &&
        <>  
        <div className={classes.container}>
          <Row>
            <Col xs={24} sm={24} md={20} lg={20} offset={2}>
              <div className={[classes.btn, classes.btnPadding].join(" ")}>
                <Button type="primary" icon={<MapSvg width={20} height={20} fill="#fff" />} size='large' className={classes.btnMap} onClick={() => setShowMap(!showMap)}>&nbsp;&nbsp;  {!showMap ? t('Εμφάνιση Χάρτη') : t('Aπόκρυψη Χάρτη')} </Button>
              </div>
            </Col>
            <Col xs={24} sm={24} md={20} lg={20} offset={2}>
              <LiefletComponent
                latitude={latitude}
                longitude={longitude}
                pois={routePoises}
                polyline={polyline}
                iconImg={<RouteSvg width={25} height={25} fill="#275674" />}
              />
            </Col>
          </Row>
        </div>
        </>
      } 
      <div className={classes.container}>
        <div className={classes.checkBoxesContainerPoint}>
          <Row>
            <Col xs={24} sm={24} md={20} lg={20} offset={2}>
              {!showMap &&
                <div className={classes.btn}><Button type="primary" icon={<MapSvg width={20} height={20} fill="#fff" />} size='large' className={classes.btnMap} onClick={() => setShowMap(!showMap)}>&nbsp;&nbsp;  {!showMap ? t('Εμφάνιση Χάρτη') : t('Aπόκρυψη Χάρτη')} </Button></div>
              }
            </Col>
          </Row>
        </div>
      
      
        <div className={classes.container2}>
          <Row>
            <Col xs={24} sm={24} md={20} lg={20} offset={2}>
              <div className={classes.text} dangerouslySetInnerHTML={{ __html: route.description }} ></div>
            </Col>
          </Row>
          <ViewPointsComponent
            lg={20}
            xs={23}
            paginationNumber={1}
            array={routePoises}
            total={routePoises.length}
            isAddOrDelete={true}
            setPoisesMarkerExploration={PoisesMarkerExploration}
            onClickAddRemove={ ()=> ''} />
        </div>

      </div>  
      
    </>
  )
}

export default Routes
